module.exports = __webpack_public_path__ + "img/right_item_bg.253fd213.png";